import {
	FETCH_MOYENPAIEMENTS_BEGIN,
	FETCH_MOYENPAIEMENTS_ERROR,
	FETCH_MOYENPAIEMENTS_SUCCESS,
	POST_MOYENPAIEMENTS_BEGIN,
	POST_MOYENPAIEMENTS_ERROR,
	POST_MOYENPAIEMENTS_RESET,
	POST_MOYENPAIEMENTS_SUCCESS,
	DELETE_MOYENPAIEMENT_BEGIN,
	DELETE_MOYENPAIEMENT_ERROR,
	DELETE_MOYENPAIEMENT_RESET,
	DELETE_MOYENPAIEMENT_SUCCESS,
	FETCH_PAYEPAR_BEGIN,
	FETCH_PAYEPAR_SUCCESS,
	FETCH_PAYEPAR_ERROR,
	POST_PAYEPAR_BEGIN,
	POST_PAYEPAR_SUCCESS,
	POST_PAYEPAR_ERROR,
	POST_PAYEPAR_RESET,
	DELETE_PAYEPAR_BEGIN,
	DELETE_PAYEPAR_SUCCESS,
	DELETE_PAYEPAR_ERROR,
	DELETE_PAYEPAR_RESET,
	FETCH_MARQUES_BEGIN,
	FETCH_MARQUES_SUCCESS,
	FETCH_MARQUES_ERROR,
	POST_MARQUE_BEGIN,
	POST_MARQUE_SUCCESS,
	POST_MARQUE_ERROR,
	POST_MARQUE_RESET,
	DELETE_MARQUE_BEGIN,
	DELETE_MARQUE_ERROR,
	DELETE_MARQUE_RESET,
	DELETE_MARQUE_SUCCESS,
	FETCH_MODELES_BEGIN,
	FETCH_MODELES_SUCCESS,
	FETCH_MODELES_ERROR,
	DELETE_MODELE_BEGIN,
	DELETE_MODELE_ERROR,
	DELETE_MODELE_RESET,
	DELETE_MODELE_SUCCESS,
	FETCH_SECTEURS_BEGIN,
	FETCH_SECTEURS_ERROR,
	FETCH_SECTEURS_SUCCESS,
	POST_SECTEURS_BEGIN,
	POST_SECTEURS_ERROR,
	POST_SECTEURS_RESET,
	POST_SECTEURS_SUCCESS,
	DELETE_SECTEUR_BEGIN,
	DELETE_SECTEUR_ERROR,
	DELETE_SECTEUR_RESET,
	DELETE_SECTEUR_SUCCESS,
	FETCH_TACHES_AUTRE_BEGIN,
	FETCH_TACHES_AUTRE_ERROR,
	FETCH_TACHES_AUTRE_SUCCESS,
	POST_TACHES_AUTRE_BEGIN,
	POST_TACHES_AUTRE_ERROR,
	POST_TACHES_AUTRE_RESET,
	POST_TACHES_AUTRE_SUCCESS,
	DELETE_TACHE_AUTRE_BEGIN,
	DELETE_TACHE_AUTRE_ERROR,
	DELETE_TACHE_AUTRE_RESET,
	DELETE_TACHE_AUTRE_SUCCESS,
	FETCH_TYPES_TV_BEGIN,
	FETCH_TYPES_TV_SUCCESS,
	FETCH_TYPES_TV_ERROR,
	POST_TYPE_TV_BEGIN,
	POST_TYPE_TV_SUCCESS,
	POST_TYPE_TV_ERROR,
	POST_TYPE_TV_RESET,
	DELETE_TYPE_TV_BEGIN,
	DELETE_TYPE_TV_SUCCESS,
	DELETE_TYPE_TV_ERROR,
	DELETE_TYPE_TV_RESET,
	FETCH_AUTRE_ENTITES_BEGIN,
	FETCH_AUTRE_ENTITES_SUCCESS,
	FETCH_AUTRE_ENTITES_ERROR,
	FETCH_FOURNISSEURS_BEGIN,
	FETCH_FOURNISSEURS_SUCCESS,
	FETCH_FOURNISSEURS_ERROR,
	FETCH_FOURNITURES_BEGIN,
	FETCH_FOURNITURES_SUCCESS,
	FETCH_FOURNITURES_ERROR,
} from "../actions/autreActions"

const initialState = {
	assurances: [],
	experts: [],
	assistances: [],
	garages: [],
	clientPassage: {},
	fetchAutreEntites: {
		loading: false,
		error: false,
	},
	fournisseurs: [],
	fetchFournisseurs: {
		loading: false,
		error: false,
	},
	fournitures: [],
	fetchFournitures: {
		loading: false,
		error: false,
	},
	moyenPaiements: [],
	marques: [],
	fetchMarques: {
		loading: false,
		error: false,
	},
	postMarque: {
		saving: false,
		saved: false,
		error: false,
		errorFields: [],
	},
	deleteMarque: {
		deleting: false,
		deleted: false,
		error: false,
	},
	modeles: [],
	fetchModeles: {
		loading: false,
		error: false,
	},
	deleteModele: {
		deleting: false,
		deleted: false,
		error: false,
	},
	fetchMoyenPaiements: {
		loading: false,
		error: false,
	},
	postMoyenPaiements: {
		saving: false,
		saved: false,
		error: false,
		errorFields: [],
	},
	deleteMoyenPaiement: {
		deleting: false,
		deleted: false,
		error: false,
	},
	secteurs: [],
	postSecteurs: {
		saving: false,
		saved: false,
		error: false,
		errorFields: [],
	},
	fetchSecteurs: {
		loading: false,
		error: false,
	},
	deleteSecteur: {
		deleted: false,
		deleting: false,
		error: false,
	},
	taches: [],
	postTaches: {
		saving: false,
		saved: false,
		error: false,
		errorFields: [],
	},
	fetchTaches: {
		loading: false,
		error: false,
	},
	deleteTache: {
		deleted: false,
		deleting: false,
		error: false,
	},
	typesTacheVehicule: [],
	fetchTypesTV: { loading: false, error: false },
	postTypeTV: { saving: false, saved: false, error: false },
	deleteTypeTV: { deleting: false, deleted: false, error: false },
	payePar: [],
	fetchPayePar: {
		loading: false,
		error: false,
	},
	postPayePar: {
		saving: false,
		saved: false,
		error: false,
	},
	deletePayePar: {
		deleted: false,
		deleting: false,
		error: false,
	},
}

export default function autreReducer(state = initialState, action) {
	switch (action.type) {
		case FETCH_FOURNISSEURS_BEGIN:
			return {
				...state,
				fetchFournisseurs: {
					loading: true,
					error: false,
				},
			}
		case FETCH_FOURNISSEURS_SUCCESS: {
			return {
				...state,
				fetchFournisseurs: {
					loading: false,
					error: false,
				},
				fournisseurs: action.payload,
			}
		}
		case FETCH_FOURNISSEURS_ERROR: {
			return {
				...state,
				fetchFournisseurs: {
					loading: false,
					error: action.payload,
				},
			}
		}
		case FETCH_FOURNITURES_BEGIN:
			return {
				...state,
				fetchFournitures: {
					loading: true,
					error: false,
				},
			}
		case FETCH_FOURNITURES_SUCCESS: {
			return {
				...state,
				fetchFournitures: {
					loading: false,
					error: false,
				},
				fournitures: action.payload,
			}
		}
		case FETCH_FOURNITURES_ERROR: {
			return {
				...state,
				fetchFournitures: {
					loading: false,
					error: action.payload,
				},
			}
		}
		case FETCH_AUTRE_ENTITES_BEGIN:
			return {
				...state,
				fetchAutreEntites: {
					loading: true,
					error: false,
				},
			}
		case FETCH_AUTRE_ENTITES_SUCCESS: {
			return {
				...state,
				fetchAutreEntites: {
					loading: false,
					error: false,
				},
				assurances: action.payload.assurances,
				assistances: action.payload.assistances,
				garages: action.payload.garages || [],
				experts: action.payload.experts,
				clientPassage: action.payload.client_passage,
			}
		}
		case FETCH_AUTRE_ENTITES_ERROR: {
			return {
				...state,
				fetchAutreEntites: {
					loading: false,
					error: action.payload,
				},
			}
		}
		case FETCH_MOYENPAIEMENTS_BEGIN:
			return {
				...state,
				fetchMoyenPaiements: {
					loading: true,
					error: false,
				},
			}
		case FETCH_MOYENPAIEMENTS_ERROR:
			return {
				...state,
				fetchMoyenPaiements: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_MOYENPAIEMENTS_SUCCESS:
			return {
				...state,
				moyenPaiements: action.payload.moyenPaiements,
				fetchMoyenPaiements: {
					loading: false,
					error: false,
				},
			}
		case POST_MOYENPAIEMENTS_BEGIN:
			return {
				...state,
				postMoyenPaiements: {
					saved: false,
					saving: true,
					error: false,
					errorFields: [],
				},
			}
		case POST_MOYENPAIEMENTS_ERROR:
			return {
				...state,
				postMoyenPaiements: {
					saved: false,
					saving: false,
					error: action.payload.error,
					errorFields: [],
				},
			}
		case POST_MOYENPAIEMENTS_SUCCESS:
			return {
				...state,
				moyenPaiements: action.payload.moyenPaiements,
				postMoyenPaiements: {
					saved: true,
					saving: false,
					error: false,
					errorFields: [],
				},
			}
		case POST_MOYENPAIEMENTS_RESET:
			return {
				...state,
				postMoyenPaiements: {
					saved: false,
					saving: false,
					error: false,
					errorFields: [],
				},
			}
		// DELETE MOYENPAIEMENT
		case DELETE_MOYENPAIEMENT_BEGIN:
			return {
				...state,
				deleteMoyenPaiement: {
					deleted: false,
					deleting: true,
					error: false,
				},
			}
		case DELETE_MOYENPAIEMENT_ERROR:
			return {
				...state,
				deleteMoyenPaiement: {
					deleted: false,
					deleting: false,
					error: action.payload.error,
				},
			}
		case DELETE_MOYENPAIEMENT_SUCCESS:
			return {
				...state,
				moyenPaiements: action.payload.moyenPaiements,
				deleteMoyenPaiement: {
					deleted: true,
					deleting: false,
					error: false,
				},
			}
		case DELETE_MOYENPAIEMENT_RESET:
			return {
				...state,
				deleteMoyenPaiement: {
					deleted: false,
					deleting: false,
					error: false,
				},
			}
		case "SET_MOYENPAIEMENTS":
			let index = state.moyenPaiements.findIndex(
				(mdp) => mdp.id === action.value.id,
			)
			if (index !== -1) {
				return {
					...state,
					moyenPaiements: [
						...state.moyenPaiements.slice(0, index),
						action.value,
						...state.moyenPaiements.slice(index + 1),
					],
				}
			} else {
				return {
					...state,
					moyenPaiements: [...state.moyenPaiements, action.value],
				}
			}
		case "REMOVE_MOYENPAIEMENTS":
			return {
				...state,
				moyenPaiements: state.moyenPaiements.filter(
					(mdp) => mdp.id !== action.value,
				),
			}
		// PAYPER
		case FETCH_PAYEPAR_BEGIN:
			return {
				...state,
				fetchPayePar: {
					loading: true,
					error: false,
				},
			}
		case FETCH_PAYEPAR_ERROR:
			return {
				...state,
				fetchPayePar: {
					loading: false,
					error: action.payload,
				},
			}
		case FETCH_PAYEPAR_SUCCESS:
			return {
				...state,
				payePar: action.payload,
				fetchPayePar: {
					loading: false,
					error: false,
				},
			}
		case POST_PAYEPAR_BEGIN:
			return {
				...state,
				postPayePar: {
					saved: false,
					saving: true,
					error: false,
					errorFields: [],
				},
			}
		case POST_PAYEPAR_ERROR:
			return {
				...state,
				postPayePar: {
					saved: false,
					saving: false,
					error: action.payload,
					errorFields: [],
				},
			}
		case POST_PAYEPAR_SUCCESS:
			return {
				...state,
				payePar: action.payload,
				postPayePar: {
					saved: true,
					saving: false,
					error: false,
					errorFields: [],
				},
			}
		case POST_PAYEPAR_RESET:
			return {
				...state,
				postPayePar: {
					saved: false,
					saving: false,
					error: false,
					errorFields: [],
				},
			}
		case DELETE_PAYEPAR_BEGIN:
			return {
				...state,
				deletePayePar: {
					deleted: false,
					deleting: true,
					error: false,
				},
			}
		case DELETE_PAYEPAR_ERROR:
			return {
				...state,
				deletePayePar: {
					deleted: false,
					deleting: false,
					error: action.payload.error,
				},
			}
		case DELETE_PAYEPAR_SUCCESS:
			return {
				...state,
				payePar: action.payload,
				deletePayePar: {
					deleted: true,
					deleting: false,
					error: false,
				},
			}
		case DELETE_PAYEPAR_RESET:
			return {
				...state,
				deletePayePar: {
					deleted: false,
					deleting: false,
					error: false,
				},
			}
		// MARQUES
		case FETCH_MARQUES_BEGIN:
			return {
				...state,
				fetchMarques: {
					loading: true,
					error: false,
				},
			}
		case FETCH_MARQUES_ERROR:
			return {
				...state,
				fetchMarques: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_MARQUES_SUCCESS:
			return {
				...state,
				marques: action.payload.marques,
				fetchMarques: {
					loading: false,
					error: false,
				},
			}
		case POST_MARQUE_BEGIN:
			return {
				...state,
				postMarque: {
					saving: true,
					saved: false,
					error: false,
					errorFields: [],
				},
			}
		case POST_MARQUE_RESET:
			return {
				...state,
				postMarque: {
					saving: false,
					saved: false,
					error: false,
					errorFields: [],
				},
			}
		case POST_MARQUE_ERROR:
			return {
				...state,
				postMarque: {
					saving: false,
					saved: false,
					error: action.payload.error,
					errorFields: [],
				},
			}
		case POST_MARQUE_SUCCESS:
			return {
				...state,
				marques: action.payload.marques,
				modeles: [],
				postMarque: {
					saving: false,
					saved: true,
					error: false,
					errorFields: [],
				},
			}
		case DELETE_MARQUE_BEGIN:
			return {
				...state,
				deleteMarque: {
					deleting: true,
					deleted: false,
					error: false,
				},
			}
		case DELETE_MARQUE_SUCCESS:
			return {
				...state,
				marques: action.payload.marques,
				modeles: [],
				deleteMarque: {
					deleting: false,
					deleted: true,
					error: false,
				},
			}
		case DELETE_MARQUE_ERROR:
			return {
				...state,
				deleteMarque: {
					deleting: false,
					deleted: false,
					error: action.payload.error,
				},
			}
		case DELETE_MARQUE_RESET:
			return {
				...state,
				deleteMarque: {
					deleting: false,
					deleted: false,
					error: false,
				},
			}
		case "UPDATE_MARQUE":
			let marqueIndex = state.marques.findIndex(
				(marque) => marque.id === action.value.id,
			)
			if (marqueIndex === -1) return state
			return {
				...state,
				marques: [
					...state.marques.slice(0, marqueIndex),
					action.value,
					...state.marques.slice(marqueIndex + 1),
				],
			}
		case "DELETE_MARQUE":
			let delMarqueIndex = state.marques.findIndex(
				(marque) => marque.id === action.value,
			)
			if (delMarqueIndex === -1) return state
			return {
				...state,
				marques: [
					...state.marques.slice(0, delMarqueIndex),
					...state.marques.slice(delMarqueIndex + 1),
				],
				modeles: [],
			}
		case "ADD_MARQUE":
			return {
				...state,
				marques: [action.value, ...state.marques],
				modeles: [],
			}
		// MODELES
		case FETCH_MODELES_BEGIN:
			return {
				...state,
				fetchModeles: {
					loading: true,
					error: false,
				},
			}
		case FETCH_MODELES_ERROR:
			return {
				...state,
				fetchModeles: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_MODELES_SUCCESS:
			return {
				...state,
				modeles: action.payload.modeles,
				fetchModeles: {
					loading: false,
					error: false,
				},
			}

		case DELETE_MODELE_BEGIN:
			return {
				...state,
				deleteModele: {
					deleting: true,
					deleted: false,
					error: false,
				},
			}
		case DELETE_MODELE_SUCCESS:
			return {
				...state,
				modeles: action.payload.modeles,
				deleteModele: {
					deleting: false,
					deleted: true,
					error: false,
				},
			}
		case DELETE_MODELE_ERROR:
			return {
				...state,
				deleteModele: {
					deleting: false,
					deleted: false,
					error: action.payload.error,
				},
			}
		case DELETE_MODELE_RESET:
			return {
				...state,
				deleteModele: {
					deleting: false,
					deleted: false,
					error: false,
				},
			}
		case "ADD_MODELE":
			return {
				...state,
				modeles: [{ id: Math.random(), nom: "" }, ...state.modeles],
			}
		case "UPDATE_MODELE":
			return {
				...state,
				modeles: [
					...state.modeles.slice(0, action.index),
					action.value,
					...state.modeles.slice(action.index + 1),
				],
			}
		case "DELETE_MODELE":
			return {
				...state,
				modeles: [
					...state.modeles.slice(0, action.value),
					...state.modeles.slice(action.value + 1),
				],
			}
		// SECTEURS
		case FETCH_SECTEURS_BEGIN:
			return {
				...state,
				fetchSecteurs: {
					loading: true,
					error: false,
				},
			}
		case FETCH_SECTEURS_ERROR:
			return {
				...state,
				fetchSecteurs: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_SECTEURS_SUCCESS:
			return {
				...state,
				secteurs: action.payload.secteurs,
				fetchSecteurs: {
					loading: false,
					error: false,
				},
			}
		case POST_SECTEURS_BEGIN:
			return {
				...state,
				postSecteurs: {
					saved: false,
					saving: true,
					error: false,
					errorFields: [],
				},
			}
		case POST_SECTEURS_ERROR:
			return {
				...state,
				postSecteurs: {
					saved: false,
					saving: false,
					error: action.payload.error,
					errorFields: [],
				},
			}
		case POST_SECTEURS_SUCCESS:
			return {
				...state,
				secteurs: action.payload.secteurs,
				postSecteurs: {
					saved: true,
					saving: false,
					error: false,
					errorFields: [],
				},
			}
		case POST_SECTEURS_RESET:
			return {
				...state,
				postSecteurs: {
					saved: false,
					saving: false,
					error: false,
					errorFields: [],
				},
			}
		// DELETE SECTEUR
		case DELETE_SECTEUR_BEGIN:
			return {
				...state,
				deleteSecteur: {
					deleted: false,
					deleting: true,
					error: false,
				},
			}
		case DELETE_SECTEUR_ERROR:
			return {
				...state,
				deleteSecteur: {
					deleted: false,
					deleting: false,
					error: action.payload.error,
				},
			}
		case DELETE_SECTEUR_SUCCESS:
			return {
				...state,
				secteurs: action.payload.secteurs,
				deleteSecteur: {
					deleted: true,
					deleting: false,
					error: false,
				},
			}
		case DELETE_SECTEUR_RESET:
			return {
				...state,
				deleteSecteur: {
					deleted: false,
					deleting: false,
					error: false,
				},
			}
		case "SET_SECTEUR":
			let ind = state.secteurs.findIndex(
				(sec) => sec.id === action.value.id,
			)
			if (ind !== -1) {
				return {
					...state,
					secteurs: [
						...state.secteurs.slice(0, ind),
						action.value,
						...state.secteurs.slice(ind + 1),
					],
				}
			} else {
				return {
					...state,
					secteurs: [...state.secteurs, action.value],
				}
			}
		// SECTEURS
		case FETCH_TACHES_AUTRE_BEGIN:
			return {
				...state,
				fetchTaches: {
					loading: true,
					error: false,
				},
			}
		case FETCH_TACHES_AUTRE_ERROR:
			return {
				...state,
				fetchTaches: {
					loading: false,
					error: action.payload.error,
				},
			}
		case FETCH_TACHES_AUTRE_SUCCESS:
			return {
				...state,
				taches: action.payload.taches,
				fetchTaches: {
					loading: false,
					error: false,
				},
			}
		case POST_TACHES_AUTRE_BEGIN:
			return {
				...state,
				postTaches: {
					saved: false,
					saving: true,
					error: false,
					errorFields: [],
				},
			}
		case POST_TACHES_AUTRE_ERROR:
			return {
				...state,
				postTaches: {
					saved: false,
					saving: false,
					error: action.payload.error,
					errorFields: [],
				},
			}
		case POST_TACHES_AUTRE_SUCCESS:
			return {
				...state,
				taches: action.payload.taches,
				postTaches: {
					saved: true,
					saving: false,
					error: false,
					errorFields: [],
				},
			}
		case POST_TACHES_AUTRE_RESET:
			return {
				...state,
				postTaches: {
					saved: false,
					saving: false,
					error: false,
					errorFields: [],
				},
			}
		// DELETE SECTEUR
		case DELETE_TACHE_AUTRE_BEGIN:
			return {
				...state,
				deleteTache: {
					deleted: false,
					deleting: true,
					error: false,
				},
			}
		case DELETE_TACHE_AUTRE_ERROR:
			return {
				...state,
				deleteTache: {
					deleted: false,
					deleting: false,
					error: action.payload.error,
				},
			}
		case DELETE_TACHE_AUTRE_SUCCESS:
			return {
				...state,
				taches: action.payload.taches,
				deleteTache: {
					deleted: true,
					deleting: false,
					error: false,
				},
			}
		case DELETE_TACHE_AUTRE_RESET:
			return {
				...state,
				deleteTache: {
					deleted: false,
					deleting: false,
					error: false,
				},
			}
		// ===== Catalogue tâches véhicule (TypeTacheVehicule) =====
		case FETCH_TYPES_TV_BEGIN:
			return { ...state, fetchTypesTV: { loading: true, error: false } }
		case FETCH_TYPES_TV_ERROR:
			return { ...state, fetchTypesTV: { loading: false, error: true } }
		case FETCH_TYPES_TV_SUCCESS:
			return {
				...state,
				typesTacheVehicule: action.payload,
				fetchTypesTV: { loading: false, error: false },
			}
		case POST_TYPE_TV_BEGIN:
			return {
				...state,
				postTypeTV: { saving: true, saved: false, error: false },
			}
		case POST_TYPE_TV_ERROR:
			return {
				...state,
				postTypeTV: { saving: false, saved: false, error: true },
			}
		case POST_TYPE_TV_SUCCESS:
			return {
				...state,
				typesTacheVehicule: action.payload,
				postTypeTV: { saving: false, saved: true, error: false },
			}
		case POST_TYPE_TV_RESET:
			return {
				...state,
				postTypeTV: { saving: false, saved: false, error: false },
			}
		case DELETE_TYPE_TV_BEGIN:
			return {
				...state,
				deleteTypeTV: { deleting: true, deleted: false, error: false },
			}
		case DELETE_TYPE_TV_ERROR:
			return {
				...state,
				deleteTypeTV: { deleting: false, deleted: false, error: true },
			}
		case DELETE_TYPE_TV_SUCCESS:
			return {
				...state,
				typesTacheVehicule: action.payload,
				deleteTypeTV: { deleting: false, deleted: true, error: false },
			}
		case DELETE_TYPE_TV_RESET:
			return {
				...state,
				deleteTypeTV: { deleting: false, deleted: false, error: false },
			}
		case "SET_TACHE":
			let index_tache = state.taches.findIndex(
				(tache) => tache.id === action.value.id,
			)
			if (index_tache !== -1) {
				return {
					...state,
					taches: [
						...state.taches.slice(0, index_tache),
						action.value,
						...state.taches.slice(index_tache + 1),
					],
				}
			} else {
				return {
					...state,
					taches: [...state.taches, action.value],
				}
			}
		case "REMOVE_TACHE":
			return {
				...state,
				taches: state.taches.filter(
					(tache) => tache.id !== action.value,
				),
			}
		case "REMOVE_SECTEUR":
			return {
				...state,
				secteurs: state.secteurs.filter(
					(sec) => sec.id !== action.value,
				),
			}
		default:
			return state
	}
}

